import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';

import { DELETE_RULE, DELETE_RULE_SUCCESS, DELETE_RULE_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* deleteRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/rules`,
      method: 'DELETE',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Attribute disabled successfully!`);
      // cogoToast.success(response?.data?.message)
      yield put({ type: DELETE_RULE_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({ type: DELETE_RULE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: DELETE_RULE_ERROR, payload: error });
  }
}

export function* watchDeleteRule() {
  yield takeEvery(DELETE_RULE, deleteRule);
}

function* deleteRuleSaga() {
  yield all([fork(watchDeleteRule)]);
}

export default deleteRuleSaga;
